import { Navigate } from 'react-router-dom';
import AdminArticles from '../Admin/pages/AdminArticles';
import AdminEvents from '../Admin/pages/AdminEvents';
import AdminShowEpisodes from '../Admin/pages/AdminShowEpisodes';
import AdminShows from '../Admin/pages/AdminShows';
import Articles from '../App/pages/Articles';
import Events from '../App/pages/Events';
import Home from '../App/pages/Home';
import ShowEpisodeDetails from '../App/pages/ShowEpisodeDetails';
import ShowEpisodes from '../App/pages/ShowEpisodes';
import Shows from '../App/pages/Shows';
import { links } from './staticContent';
import ArticleDetails from '../App/pages/ArticleDetails';
import Projects from '../App/pages/Projects';
import AdminProjects from '../Admin/pages/AdminProjects';
import ProjectDetails from '../App/pages/ProjectDetails';
import About from '../App/pages/About';

export const routeMapper = [
    {
        pathname: '/',
        appComponent: <Home />,
        adminComponent: <Navigate to={`/admin${links.events}`} replace={true} />,
    },
    {
        pathname: links.events,
        appComponent: <Events />,
        adminComponent: <AdminEvents />,
    },
    {
        pathname: links.shows,
        appComponent: <Shows />,
        adminComponent: <AdminShows />,
    },
    {
        pathname: links.articles,
        appComponent: <Articles />,
        adminComponent: <AdminArticles />,
    },
    {
        pathname: `${links.articles}/:articleId`,
        appComponent: <ArticleDetails />,
    },
    {
        pathname: links.projects,
        appComponent: <Projects />,
        adminComponent: <AdminProjects />,
    },
    {
        pathname: `${links.projects}/:projectId`,
        appComponent: <ProjectDetails />,
    },
    {
        pathname: `${links.shows}/:showId`,
        appComponent: <ShowEpisodes />,
        adminComponent: <AdminShowEpisodes />,
    },
    {
        pathname: `${links.shows}/:showId/:episodeId`,
        appComponent: <ShowEpisodeDetails />,
    },
    {
        pathname: `${links.about}`,
        appComponent: <About />,
    },
];
